import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { PersonalSpaceDetailQuery } from './PersonalSpaceDetailQuery.graphql.ts';

export const preloadPersonalSpaceDetail = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: PersonalSpaceDetailQuery,
	});
};
